import { render } from "./WarehouseDatatableFormDestinationWarehouse.vue?vue&type=template&id=99135c62"
import script from "./WarehouseDatatableFormDestinationWarehouse.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableFormDestinationWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__